import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import classNames from 'classnames/bind';
import { getByte } from 'app/libs/stringUtils';
import styles from './Textarea.module.scss';

const cx = classNames.bind(styles);

function Textarea({
	id = 'textarea_1',
	name,
	value = '',
	theme = '',
	style = null,
	useLabel = false,
	labelText = '내용 입력하기',
	labelStyle = undefined,
	placeholder = '',
	useAutoHeight = false,
	lineHeight = 27,
	minRow = 1,
	maxRow = 0,
	useByte = false,
	useMaxLength = false,
	maxLength = 100,
	onChange = () => console.warn('onChange is not defined'),
	onCopy = () => console.warn('onCopy is not defined'),
	onPaste = () => console.warn('onPaste is not defined'),
	disabled = false,
	testId = 'tarea',
	boxClass = '',
	textAreaClass = '',
}) {
	const queryEl = useRef();

	// useAutoHeight
	const fnAutoHeight = useCallback(() => {
		queryEl.current.style.height = '0px';
		queryEl.current.style.height = `${queryEl.current.scrollHeight}px`;
	}, []);

	useEffect(() => {
		if (useAutoHeight) fnAutoHeight();
	}, [useAutoHeight, fnAutoHeight]);

	const textareaStyle = useMemo(
		() => ({
			minHeight: minRow ? lineHeight * minRow : 'auto',
			maxHeight: maxRow ? lineHeight * maxRow : 'auto',
			lineHeight: `${lineHeight}px`,
		}),
		[lineHeight, maxRow, minRow],
	);

	const handleChange = useCallback(
		(e) => {
			if (maxLength) {
				if (e.target.value.length > maxLength) {
					return;
				}
			}

			onChange(e);
			// useAutoHeight
			if (useAutoHeight) fnAutoHeight();
		},
		[maxLength, onChange, useAutoHeight, fnAutoHeight],
	);

	return (
		<div
			className={cx('uitextarea', theme)}
			style={style}
		>
			<label
				htmlFor={id}
				className={cx('textarea_ttl', { blind: !useLabel })}
				style={labelStyle}
			>
				{labelText}
			</label>
			<div className={cx('textarea_box', boxClass)}>
				<textarea
					id={id}
					name={name}
					value={value}
					className={cx('textarea_text', textAreaClass)}
					placeholder={placeholder}
					ref={queryEl}
					onChange={handleChange}
					style={textareaStyle}
					data-testid={testId}
					onCopy={onCopy}
					onPaste={onPaste}
					disabled={disabled}
					maxLength={maxLength}
				/>
			</div>
			{useMaxLength && (
				<span className={cx('textarea_len')}>
					<strong>{value.length}</strong> / {maxLength}자
				</span>
			)}
			{useByte && (
				<span className={cx('textarea_len')}>
					<strong>{getByte(value)}</strong> / {maxLength * 3}byte
				</span>
			)}
		</div>
	);
}

export default Textarea;
